document.addEventListener('DOMContentLoaded', function () {

    this.querySelector('#sidemenu_btn').addEventListener('click', () => {
        this.querySelector('.header__icon--menu').click();
    })

    // タブ切り替え
    function tabFunc(btn, target) {
        let btns = document.querySelectorAll(btn);
        if (btns.length < 1) return;
        btns.forEach(function (btn, index) {
            btn.addEventListener('click', function () {
                btns.forEach(function (btn) {
                    btn.classList.remove('is_active');
                });
                btn.classList.add('is_active');
                let elements = document.querySelectorAll(target);
                elements.forEach(function (element) {
                    element.classList.remove('is_active');
                });
                elements[index].classList.add('is_active');
            });
        });
    }
    tabFunc('.js_sidemenu_tabmenu_btn', '.js_sidemenu_tabmenu_item');

    // アコーディオン(click)
    // function accoFunk(btn, target) {
    //     let btns = document.querySelectorAll(btn);
    //     if (btns.length < 1) return;
    //     btns.forEach(function (btn, index) {
    //         btn.addEventListener('click', function () {
    //             btn.classList.toggle('is_open');
    //             let elements = document.querySelectorAll(target);
    //             let subElements = elements[index].querySelectorAll('ul.js_sidemenu_acco_body');
    //             if (subElements.length > 0) {
    //                 let scrollHeight = elements[index].scrollHeight;
    //                 subElements.forEach(sub => {
    //                     scrollHeight += sub.scrollHeight;
    //                 });
    //                 elements[index].style.maxHeight = btn.classList.contains('is_open') ? scrollHeight + "px" : "0px";
    //             } else {
    //                 elements[index].style.maxHeight = btn.classList.contains('is_open') ? elements[index].scrollHeight + "px" : "0px";
    //             }
    //         });
    //     });
    // }
    // accoFunk('.js_sidemenu_acco_btn', '.js_sidemenu_acco_body');
})